<script setup lang="ts">
import type { ProductInformation } from "~/models/Content/ContentProducts"

const props = defineProps<{
  selectedProduct: ProductInformation
  showPayment: boolean
  price?: CrystallizeVariantPrice
}>()

const route = useRoute<"productCheckout" | "login">()

const productIsFree = computed(() => props.price?.actual === 0)
</script>

<template>
  <div
    v-if="showPayment || selectedProduct.ean"
    class="flex max-w-[720px] items-center justify-between gap-14 rounded-2xl bg-white p-8 font-national2 text-xl shadow-xl <lg:flex-col"
  >
    <UProductImage
      :product="selectedProduct"
      class="flex aspect-square h-[232px] items-center justify-center rounded-md bg-[--theme-lightest]"
      img-class="max-h-[80%]"
    />
    <div class="flex flex-col gap-2">
      <p class="mb-4">
        <b v-text="selectedProduct.curriculumFor" />
      </p>
      <h3
        class="text- font-national2compressed text-4xl text-[--theme-darkest]"
      >
        <b>Kunne {{ selectedProduct.title }}</b>
      </h3>
      <div class="flex flex-col justify-between">
        <br />
        <div
          v-if="showPayment && !productIsFree"
          class="flex flex-col justify-between"
        >
          <div v-if="price?.actual">
            <UPrice :price="price" view-type="list" />
            <p
              class="mt-3 text-mobile-article-p1 leading-[26px] lg:text-marketing-desktop-p1-p1-small lg:leading-[30px]"
            >
              <i>Avsluttes automatisk etter semesterslutt</i>
            </p>
          </div>
          <p v-else>
            Ops! Fant ikke pris for dette produktet, prøv igjen
            senere.
          </p>
          <br />
        </div>
        <div>
          <UButton
            v-show="!productIsFree && showPayment"
            type="submit"
            pill
            theme="cta"
            variant="filled"
          >
            Betal
          </UButton>

          <UButton
            v-show="productIsFree || !showPayment"
            :to="`/produkter/${route.params.product}/${selectedProduct?.variantKey}`"
            pill
            theme="cta"
            variant="filled"
            data-pendo="checkout-prov-gratis"
          >
            Prøv gratis
          </UButton>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="flex flex-col gap-6 rounded-2xl bg-white font-national2 shadow-md sm:p-16"
  >
    <p>
      Ops, noe gikk galt, og vi greide ikke hente informasjon om
      produktet.
    </p>
    <p>
      Prøv igjen senere.
      <UContactCustomerService /> om feilen vedvarer.
    </p>
  </div>
</template>
